var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCommentQuickAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.373 4.75V.993h18.659v13.71h-2.855v5.023L22.22 17.05V4.75H9.373Zm-6.11 15.235H0V6.274h18.659v13.71h-9.85l-5.546 5.024v-5.023Zm1.58-4.469h8.973v-1.523H4.843v1.523Zm10.604-4.773H3.212v1.523h12.235v-1.523Z",
  fill: "#98A4AF"
})));
export { SvgCommentQuickAdd as ReactComponent };
export default __webpack_public_path__ + "12b0b76aed93f8aa577309e4172437d5.svg";